import {gql} from '@apollo/client'

export const GET_TERMINAL_LIST = gql`
  query Terminals {
    terminals {
      nodes {
        id
        name
        serialNumber
        deviceModelNumber
      }
      totalCount
    }
  }
`

export const GET_TERMINAL = gql`
  query Terminal($id: UUID!) {
    terminal(id: $id) {
      id
      name
      serialNumber
      status
      deviceModelNumber
    }
  }
`

export const CREATE_TERMINAL = gql`
  mutation CreateTerminal($terminal: TerminalInput!) {
    createTerminal(input: {terminal: $terminal}) {
      clientMutationId
    }
  }
`

export const UPDATE_TERMINAL = gql`
  mutation UpdateTerminal($terminal: TerminalPatch!, $id: UUID!) {
    updateTerminal(input: {patch: $terminal, id: $id}) {
      clientMutationId
    }
  }
`

export const GET_USER_STRIPE_TERMINAL = gql`
  query GetUserTerminal($locationId: UUID!) {
    terminalReaders: getTerminalReaderByLocationId(pLocationId: $locationId) {
      nodes {
        id
        registrationCode
        name
        terminalId
        paxConnectionType
        testMode
        communicationSettings
        clientCertificate
      }
    }
  }
`
